<template>
  <section class="partners-unit active-partners-unit">
    <section class="partners-basic-info">
      <div class="partners-object">
        <div class="partners-unit-link" @click="open_new_window(`/company/${company.id}/intro/?page=1`)">
          <div
            class="partners-profile-image"
            :style="{'backgroundImage':`url('${src + company.logo}')`}"
           >
           
          </div>
        </div>
        <star-rating v-model="company.star_point"
            :read-only="true"
            :star-size="15"
        ></star-rating>
        <div class="info_con">
              <ul class="info_list" style="padding-left:0px;">
                <li class="info_item"><span class="info_title">관심 : </span> <span class="info_text">{{company.favorite_count}}</span></li>
                <li class="info_item"><span class="info_title">문의 : </span> <span class="info_text">{{company.contact_count}}</span></li>
                <li class="info_item"><span class="info_title">리뷰 : </span> <span class="info_text">{{company.review_count}}</span></li>
                <li class="info_item"><span class="info_title">조회 : </span> <span class="info_text">{{company.view_count}}</span></li>
              </ul>  
          </div>
      </div>
      <section class="partners-basic-info-body">
        <div class="partners-unit-heading">          
          <router-link class="partners-unit-username-link" :to="`/company/${company.id}/intro/?page=1`" target="_blank">
          <h4 class="partners-username">
            {{company.name}} 
          </h4>     
          </router-link>
          <div class="favorite_company" @click.stop="toggle_favorite(company.id,company.favorite )">
                <i v-if="company.favorite" class="fas fa-heart" style="color:red"></i>
                <i  v-else class="far fa-heart"></i>
          </div>
          <span v-if="company.is_premium" style="background-color:blue" class="label label-sm label-partners-availability possible">프리미엄</span>
          <router-link class="partners-unit-username-link" :to="`/company/${company.id}/intro/?page=1`"  target="_blank" style="margin-right:5px;"
             v-for="tag in company.location"
             :key="tag"
          >
            <span class="label label-sm label-partners-availability possible">{{tag}}</span>
          </router-link>
         
        </div>
        <section class="partners-business-info">
          <router-link class="partners-unit-link" :to="`/company/${company.id}/intro/?page=1`"
              v-for="tag in company.popcon_category"
               target="_blank"
             :key="tag"
          >
            <span class="job">
              <i class="fas fa-scroll"></i> {{tag}}
            </span>
          </router-link>        
        </section>
      
        <div class="partners-desc">         
            <p>{{company.intro_text}}</p>        
        </div>
        <section class="partners-skill-list" style="">
          <router-link :to="`/company/${company.id}/intro/?page=1`"
             v-for="tag in company.service"
             :key="tag" 
              target="_blank"
          >
            <span class="partners-skill label-skill">{{tag}}</span>         
          </router-link>
        </section>
      </section>
    </section>
    <section class="partners-additional-info">
      <div class="partners-stats">
        <div class="info_btn"  @click="open_new_window(`/company/${company.id}/intro/?page=1`)">콘텐츠</div>
        <div class="info_btn"  @click="open_new_window(`/company/${company.id}/review/`)" style="">고객 리뷰</div>
        <div class="info_btn"  @click="open_new_window(`/company/${company.id}/portfolio/`)">제품/서비스</div>
        <div class="info_btn"  @click="open_new_window(`/company/${company.id}/event/`)" style="">이벤트 </div>
      </div>      
    </section>
  </section>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props:["company"],
  methods:{
    open_new_window(str){
      window.open(str)
    },
    toggle_favorite(str, favorite){
      if(!localStorage.getItem("login")){alert("관심 등록은 로그인후에 이용이 가능합니다.")}
      else{
        if(favorite){ 
            if(confirm("관심을 해제하시겠습니까?")){
              this.$http.post("app/toggle_favorite_company",this.qs({"id":str})).then(res=>{         
                this.$toasted.success("관심 해제 되었습니다.")  
                EventBus.$emit("favorite_company_list")         
              })  
            }
          }else{
            this.$http.post("app/toggle_favorite_company",this.qs({"id":str})).then(res=>{         
                EventBus.$emit("favorite_company_list")         
                this.$toasted.success("관심 등록 되었습니다. 메인페이지에서 확인하실 수 있습니다.")  
            })  
          }
      }                    
    },
  },
};
</script>

<style scoped lang="scss">
.partners-unit {
  position: relative;
  min-height: 120px;
  overflow: hidden;
  margin: 0 0 5px;
  padding: 22px;
  padding-bottom: 40px;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #dedede;
  display: block;
  border-width: 1px 1px 1px 1px;
  &:hover {
    border-width: 1px 1px 1px 1px;
    border-color: #2099bb;
    border-style: solid;
  }
  .favorite_company{
      display: inline-block;
      cursor: pointer;
      vertical-align: sub;
      margin-left: 10px;
    }
  .partners-basic-info {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 626px;
    float: left;
    .partners-object {
      margin-right: 30px;
      width: 150px;
      float: left;
      text-align: center;
      position: relative;
      
      .info_con{
        position: absolute;
        top: 109px;
        left: 2px;
        width: 150px;
        height: 60px;
        .info_list{
          .info_item{
            float: left;
            display: block;
            width: 75px;
            font-size: 14px;
            line-height: 20px;
            .info_title{
              color: #696969
            }
            .info_text{
              color: #333;
            }
          }
        }
      }
      .partners-unit-link {
        color: #666666;
        .partners-profile-image {
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          height: 90px;          
        
          position: relative;
          cursor: pointer;          
        }
      }
    }
    .partners-basic-info-body {
      width:444px;
      position: relative;
      zoom: 1;     
      float:left;
      .partners-unit-heading {
        position: relative;
        margin-bottom: 10px;
        cursor: pointer;
        *zoom: 1;
        .partners-username {
          margin: 0;
          line-height: 1.5;
          float: left;
          color: #2099bb;
          font-size: 18px;
          a {
            color: #2099bb;
            text-decoration: none;
          }
        }
    






        .label {
          position: relative;
          top: 3px;
          left: 10px;
          background-color: #07b481;
          display: inline;
          padding: 0.2em 0.6em 0.2em;
          font-size: 75%;
          font-weight: bold;
          line-height: 1;
          color: #fff;
          text-align: center;
          white-space: nowrap;
          vertical-align: baseline;
          border-radius: 0.2em;
          font-size: 12px;
          line-height: 1;
          font-weight: normal;
        }
      }
      .partners-business-info {
        line-height: 16px;
        font-weight: bold;
        margin-bottom: 8px;
        font-size: 14px;
        .partners-unit-link {
          color: #666666;
          .job {
            padding-right: 10px;
            border-right: 1px solid #dedede;
            margin-right: 10px;
          }
          
          .form-of-business {
            margin-left: -5px;
          }
        }
        .partners-unit-link:last-child{
          .job {
            border-right:none!important;
          }
        }
      }
      .partners-desc {
        margin-bottom: 15px;
        a {
          text-decoration: none;
        }
        p {
          font-size: 13px;
          line-height: 20px;
          margin: 0;
          color: #999;
        }
      }
      .partners-skill {
        margin-right: 5px;
        background-color: #e5e7e8;
        color: #555555;
        font-size: 12px;
        border-radius: 2px;
        line-height: 1;
        font-weight: normal;
        padding: 0.2em 0.6em 0.2em;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
      }
    }
  }
  .partners-additional-info {
    box-sizing: border-box;
    width: 220px;
    float: right;
    display: block;
   .partners-stats{
     display: table;
     margin-left: 10px;
    .info_btn{
      width: 90px;
      height: 65px;
      line-height: 60px;
      border: 1px solid #ddd;
      border-radius: 3px;
      color: #696969; 
      float: left;
      font-size: 12px;
      text-align: center;     
      display: table-cell;
      vertical-align: middle;
      margin: 2px;
      cursor: pointer;
    }  
   }
    .partners-authentication {
      color: #666;
      .partners-authorized {
        width: 100px;
        display: inline-block;
        line-height: 16px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/SPA/CompanyList/Components/CompanyItem.vue